export type TSeverity = 'info' | 'success' | 'warning' | 'danger' | 'primary' | 'secondary' | 'light' | 'dark';

export class Severity {
    static INFO: TSeverity = 'info';
    static SUCCESS: TSeverity = 'success';
    static WARNING: TSeverity = 'warning';
    static DANGER: TSeverity = 'danger';
    static PRIMARY: TSeverity = 'primary';
    static SECONDARY: TSeverity = 'secondary';
    static LIGHT: TSeverity = 'light';
    static DARK: TSeverity = 'dark';
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/messenger/Severity.ts